import * as dxo from '@fullstory/proto/fs/services/dx-objects';
import { defaultCacheKey } from '@fullstory/requests';

export const funnelCacheKeysToInvalidate = (orgId: string) => {
  const endpoint = dxo.FunnelsPublic.GetAllFunnelsEndpoint;
  return [defaultCacheKey(endpoint, { orgId, includeArchived: true })];
};
